<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Checkins" subtitle="See your checkin history for this membership." />

	<app-content-body class="checkins" no-padding="true" :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="You've not checked in yet!">

		<div v-for="year in years" :key="year">
        
            <div class="checkins-year">{{ year }}</div>

            <div v-for="checkin in checkins[year]" :key="checkin.id" class="checkins-item">{{ checkin.date | localDate('MMMM Do') }} @ {{ checkin.date | localDate('h:mma') }}</div>
        
        </div>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			pagination: false,
			endpoint: 'membership/checkins',
			live: 'membership/checkins'
		}

	},

    computed: {
    
        years: function() {

            var years = []
        
            this.$_.each(this.collection, function(item) {

                years.push(item.year)
            
            })

            return years
        
        },
    
        checkins: function() {
        
            var checkins = {}

            this.$_.each(this.years, function(year) {
            
                checkins[year] = []
            
            })

            this.$_.each(this.collection, function(item) {
            
                checkins[item.year].push(item)
            
            })

            return checkins
        
        }
    
    }

}

</script>

<style scoped>

.checkins:after {
    display: block;
    border-right: 2px solid #ddd;
    position: absolute;
    content: '';
    width: 128px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1;
}

.checkins-year {
    font-size: 24px;
    color: #4d5b6e;
    font-weight: 500;
    z-index: 2;
    padding: 20px;
    width: 126px;
    margin-bottom: 10px;
}

.checkins-year:after {
    position: absolute;
    content: '';
    display: block;
    right: -2px;
    width: 20px;
    top: 50%;
    height: 2px;
    margin-top: -1px;
    background-color: #ddd;
    z-index: 1;
}

.checkins-year:before {
    position: absolute;
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #4d5b6e;
    right: -9px;
    top: 50%;
    margin-top: -6px;
    z-index: 2;
}

.checkins-item {
    font-size: 16px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ddd;
    margin-left: 148px;
    margin-right: 20px;
    padding: 10px;
    margin-bottom: 10px;
}

.checkins-item:before {
    position: absolute;
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: #ffbe7a;
    left: -25px;
    top: 50%;
    margin-top: -4px;
    z-index: 2;
}

.checkins-item:after {
    position: absolute;
    content: '';
    display: block;
    left: -25px;
    width: 25px;
    top: 50%;
    height: 2px;
    margin-top: -1px;
    background-color: #ddd;
    z-index: 1;
}

</style>